import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import CustomButton from './CustomButton';
import Typography from '@material-ui/core/Typography';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function Relay05() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">

        <Box my={8}>
          <Typography className="font-weight-bold my-2" variant="h6" component="h5">
            第５回八戸リレーマラソン中止
          </Typography>
          　今年１１月に開催を予定していた第５回八戸リレーマラソンｉｎ東運動公園（デーリー東北新聞社、エスプロモ主催）は、新型コロナウイルスの感染収束の見通しが立たない中、参加者と関係者の健康と安全を第一に考え、中止とさせていただきます。開催を楽しみにしてくださった皆さまには大変ご迷惑をお掛けしますが、ご理解いただきますようお願い申し上げます。
          <Box className="font-weight-bold" textAlign="right">
            2020年8月7日<br/>
            デーリー東北新聞社<br />
            エスプロモ株式会社<br/>
          </Box>
        </Box>

      </div>
    </div>
  );
}

export default Relay05;
